import styled from '@emotion/styled';
import { SCREEN_BREAKPOINTS } from '../../../constants';

export const CarouselNavButton = styled.button`
  position: absolute;
  top: 50%;
  z-index: 1;
  width: 20px;
  padding: 0;
  transform: translate(0, -50%);
  &[data-type='prev'] {
    left: -5%;
    transform: rotate(180deg);
  }
  &[data-type='next'] {
    right: -5%;
  }
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    top: 0;
    width: 50px;
    height: 100%;
    transform: rotate(0deg);
    svg {
      display: none;
    }
  }
  svg {
    width: 100%;
  }
  &:hover svg,
  &:focus svg {
    fill: none;
  }
`;
